import type { SVGProps } from 'react';

const SvgSync = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10.75 9.55a.502.502 0 0 0-.75.43v4.04c0 .39.42.63.75.43l3.5-2.02c.33-.19.33-.67 0-.87l-3.5-2.02zM4 12c0-2.14.83-4.15 2.34-5.66a.996.996 0 1 0-1.41-1.41A9.93 9.93 0 0 0 2 12c0 2.67 1.04 5.18 2.93 7.07.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41A7.95 7.95 0 0 1 4.01 12zm15.07-7.07a.996.996 0 1 0-1.41 1.41A7.95 7.95 0 0 1 20 12c0 2.14-.83 4.15-2.34 5.66a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29A9.93 9.93 0 0 0 22.01 12c0-2.67-1.04-5.18-2.93-7.07z"
    />
    <path
      fill="currentcolor"
      d="M9.17 7.76a.996.996 0 0 0-1.41 0A5.97 5.97 0 0 0 6 12c0 1.6.62 3.11 1.76 4.24.2.19.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41A3.95 3.95 0 0 1 8.01 12c0-1.07.42-2.07 1.17-2.83a.996.996 0 0 0 0-1.41zm7.07 0a.996.996 0 1 0-1.41 1.41C15.59 9.92 16 10.93 16 12s-.42 2.07-1.17 2.83a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29A5.97 5.97 0 0 0 18.01 12c0-1.6-.62-3.11-1.76-4.24z"
    />
  </svg>
);
export default SvgSync;
